module.exports = __webpack_public_path__ + "static/media/events_08.591efd9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_08.jpg
// module id = 5926
// module chunks = 0